import axios from '@/utils/request'

const needLoginUrl = []

export default {
  needLoginUrl
}
